import React, { useState } from "react"

import RadioInput from "../inputs/RadioInput"
import NewMortgage from "../NewAsset/forms/mortgage"

interface Props {
  onNext(): void
}

const Mortgage = ({ onNext }: Props) => {
  const [hasItem, setHasItem] = useState("")

  return (
    <>
      <span className="db light-silver fw4 f5 mb2">Add Debts</span>
      <h1 className="page-title">Do you have a mortgage?</h1>
      <RadioInput
        options={[
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ]}
        value={hasItem}
        onChange={val => setHasItem(val)}
      />
      {hasItem === "yes" &&
        <div className="mt5">
          <NewMortgage hideTitle onBack={() => setHasItem("no")} onSuccess={onNext} />
        </div>
      }
      {hasItem === "no" &&
        <button onClick={onNext} className="mt5 button -primary">Continue</button>
      }
    </>
  )
}

export default Mortgage
